import React, { useEffect } from 'react';
import { Activity, Heart, Zap, Shield, Users } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from '@/components/common/Link';
export default function TestosteroneReplacementTherapyTrt() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);
  const handleCalendlyClick = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/mfloresdo/30min"
      });
    }
  };
  return <section className="py-6 px-6 bg-background">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          {}
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-semibold text-foreground mb-3 leading-tight">
              IronPeak Men's Health — Services
              <div className="!text-3xl">Feel Strong, Sharp, and Confident Again</div>
            </h1>
            <p className="text-lg md:text-xl text-muted-dark max-w-4xl mx-auto leading-relaxed mt-3">
              We identify the root causes of fatigue, weight gain, low libido, and brain fog—then build a personalized plan that fits your life.
            </p>
          </div>

          {}
          <div className="mb-12">
            <Card className="card border-2 border-muted-light shadow-soft bg-primary-light-bg">
              <CardHeader className="pb-4">
                <CardTitle className="text-2xl md:text-3xl font-semibold text-foreground text-center">
                  Common Reasons Men Come to IronPeak:
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="text-left text-base md:text-lg text-foreground list-none grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 max-w-4xl mx-auto">
                  <li className="flex items-start">
                    <span className="text-primary mr-3 font-bold text-xl">•</span>
                    <span>Low energy, fatigue, burnout</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-primary mr-3 font-bold text-xl">•</span>
                    <span>Low libido, ED, sexual performance issues</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-primary mr-3 font-bold text-xl">•</span>
                    <span>Stubborn belly fat &amp; poor metabolism</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-primary mr-3 font-bold text-xl">•</span>
                    <span>Brain fog, poor focus, low motivation</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-primary mr-3 font-bold text-xl">•</span>
                    <span>Poor recovery &amp; muscle loss</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-primary mr-3 font-bold text-xl">•</span>
                    <span>Hair loss &amp; accelerated aging</span>
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="mb-8">
            <Card className="card p-8 border-2 border-muted-light">
              <CardHeader className="pb-3">
                <CardTitle className="text-3xl md:text-4xl font-semibold text-foreground text-center">
                  How It Works
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3 text-left max-w-4xl mx-auto">
                <div>
                  <h4 className="text-lg md:text-xl font-semibold text-foreground mb-1">
                    Medical Intake &amp; Labs
                  </h4>
                  <p className="text-base md:text-lg text-muted-dark leading-relaxed">
                    We review symptoms, history, lifestyle factors, and lab data to understand the full picture.
                  </p>
                </div>
                <div>
                  <h4 className="text-lg md:text-xl font-semibold text-foreground mb-1">
                    Personalized Physician Plan
                  </h4>
                  <p className="text-base md:text-lg text-muted-dark leading-relaxed">
                    If treatment is appropriate, we build a plan tailored to your physiology, goals, and risk profile.
                  </p>
                </div>
                <div>
                  <h4 className="text-lg md:text-xl font-semibold text-foreground mb-1">
                    Ongoing Optimization &amp; Follow-Up
                  </h4>
                  <p className="text-base md:text-lg text-muted-dark leading-relaxed">
                    Regular follow-ups, lab monitoring, and adjustments—focused on long-term health, not quick fixes.
                  </p>
                </div>
              </CardContent>
            </Card>
            
            <div className="my-8 flex justify-center">
              <Button onClick={handleCalendlyClick} size="lg" className="bg-accent text-accent-foreground hover:bg-accent-hover active:bg-accent-active hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0 transition-all duration-150 ease-[cubic-bezier(0.34,1.56,0.64,1)] focus-visible:ring-accent/40">
                Schedule a Consultation
              </Button>
            </div>
            <p className="text-sm text-muted-dark mt-3 text-center">
              No pressure. Medical evaluation first. Treatment only if appropriate.
            </p>
          </div>
        </div>
      </div>
    </section>;
}